export const VOUCHER_FILTER_TYPE = {
  PLAN: 'plan',
  CITY: 'city',
  FIRST_SUBSCRIPTION: 'first_subscription',
  SPECIFIC_CLIENT: 'specific_client',
  MINIMUM_SUBSCRIPTION_DURATION: 'minimum_subscription_duration',
  MINIMUM_PRICE_THRESHOLD: 'minimum_price_threshold',
};
